import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { Tour as TourContract } from '@luxuryescapes/contract-svc-tour';

import { getTours } from '~/services/ToursService';

export interface TourOption {
  id: string;
  name: string;
}

export const tourSearchQueryKeys = {
  all: ['tour-search'] as const,
  lists: () => [...tourSearchQueryKeys.all, 'list'] as const,
  list: (searchString: string) => [...tourSearchQueryKeys.lists(), searchString] as const,
};

const RESULT_LIMIT = 20;

/** Callers debounce, so each settled term is its own cache entry. */
export function useGetTourOptions(searchString = '') {
  return useQuery({
    queryKey: tourSearchQueryKeys.list(searchString),
    queryFn: async (): Promise<Array<TourOption>> => {
      const response = await getTours({
        page: '1',
        per_page: String(RESULT_LIMIT),
        searchString,
      } as Record<string, unknown>);

      const tours: Array<TourContract.Tour> = response?.result?.tours ?? [];

      return tours.map((tour) => ({ id: tour.id, name: tour.name }));
    },
    placeholderData: keepPreviousData,
  });
}
